
import axios from 'axios'
//const url = "http://localhost/php/paul-rodney";
const url = "https://paul-rodney.com"

const api = axios.create({
    baseURL:`${url}/routes`
})

export {api, url}